const discoverySection = {
  discovery: {
    title: 'Descubra a Creditas',
  },
  cards: {
    car_loan: {
      title: 'Empréstimo com Veículo',
    },
    home_loan: {
      title: 'Empréstimo com Imóvel',
    },
    insurance: {
      title: 'Seguros',
      link: 'https://www.minutoseguros.com.br/',
    },
    payroll_loan: {
      title: 'Empréstimo Consignado',
      link: 'https://www.creditas.com/emprestimo/consignado-privado',
    },
  },
};

export { discoverySection };
